import React, { useState, useEffect } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
// css
import styles from "./MealsPop.module.scss";
import Select from "react-select";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import {
  useAddCategoryMutation,
  useUpdateCategoryMutation,
} from "../../../store/services/categoryService";

const CategoryPop = ({ title, modalOpen, setModalOpen, edit, meals }) => {
  console.log("meals==>", meals);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onTouched", // Validation mode set to 'onTouched'
    defaultValues: {
      name: edit?.name || "",
      parentCategory: edit?.parentCategory || "",
      status: edit?.status || "active",
    },
  });

  const [addCategory, { isLoading: isAdding }] = useAddCategoryMutation();
  const [updateCategory, { isLoading: isUpdating }] =
    useUpdateCategoryMutation();

  // Submit handle
  const onSubmit = async (data) => {
    if (edit == null) {
      data.type = "MEAL";
    }
    try {
      if (edit !== null) {
        // Update existing meal
        await updateCategory({
          mealId: edit._id,
          updatedData: data,
        });
      } else {
        await addCategory(data).unwrap(); // Call deleteMeal and handle success
      }
      setModalOpen(false);
      return toast.success(
        `Category ${edit ? "updated" : "Added"} successfully`
      );
    } catch (error) {
      console.error("Failed to delete the Category:", error); // Handle error
    }
  };

  const hideHandler = () => {
    setModalOpen(false);
  };

  const [unit, setUnit] = useState([]);
  const [selectedIngredients, setSelectedIngredients] = useState({});

  const handleIngredientChange = (selectedOptions) => {
    setSelectedIngredients(selectedOptions || []);
    const mealValues = selectedOptions.value || null;
    setValue("parentCategory", mealValues); // Update react-hook-form state with an array of values
  };

  useEffect(() => {
    if (!meals?.data?.length) {
      return;
    }

    const unit = meals?.data?.map((item) => ({
      value: item?._id,
      label: item?.name,
    }));

    const data = edit?.parentCategory
      ? unit.find((option) => edit.parentCategory.includes(option.value))
      : null;
    setSelectedIngredients(data);
    setUnit(unit);
  }, [meals?.data]);

  return (
    <Modal
      show={modalOpen}
      className={`${styles.MealsPop} transparentModal`}
      onHide={hideHandler}
      backdrop={true}
      keyboard={false}
      centered
    >
      <Modal.Body className={`${styles.modalBody}`}>
        <div className="mx-auto">
          <h3 className="m-0 fw-bold themeBlue">{title}</h3>
          <Col lg="12" className="my-2">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Col lg="12" md="12" className="my-2">
                {/* Name Field */}
                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Name
                  </label>
                  <input
                    type="text"
                    placeholder="Enter name"
                    className="form-control"
                    {...register("name", {
                      required: "Please enter name",
                      validate: (value) => {
                        if (/^\s/.test(value)) {
                          return "Name cannot start with a space";
                        }
                        // if (/[^a-zA-Z0-9\s]/.test(value)) {
                        //   return "Name cannot include special characters or emojis";
                        // }
                        return true;
                      },
                    })}
                  />
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </div>

                {/* Measure Unit (Select) */}
                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Parent Category
                  </label>
                  <Select
                    name="parentCategory"
                    options={unit}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    value={selectedIngredients}
                    onChange={handleIngredientChange}
                    placeholder="Select parent category"
                  />
                  {errors.unit && (
                    <span className="text-danger">{errors.unit.message}</span>
                  )}
                </div>

                {/* Status Field */}
                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Status
                  </label>
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-start gap-10 ps-2 flex-wrap">
                    <li className="d-flex align-items-center">
                      <input
                        type="radio"
                        value="active"
                        {...register("status", {
                          required: "Status is required",
                        })}
                        className="form-check"
                      />
                      <label className="form-label fw-sbold text-muted ps-2 m-0">
                        Active
                      </label>
                    </li>
                    <li className="d-flex align-items-center">
                      <input
                        type="radio"
                        value="inactive"
                        {...register("status", {
                          required: "Status is required",
                        })}
                        className="form-check"
                      />
                      <label className="form-label fw-sbold text-muted ps-2 m-0">
                        Inactive
                      </label>
                    </li>
                  </ul>
                  {errors.status && (
                    <span className="text-danger">{errors.status.message}</span>
                  )}
                </div>
              </Col>

              {/* Submit & Cancel Buttons */}
              <Col lg="12" className="my-2">
                <div className="d-flex align-items-center justify-content-center gap-10">
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn"
                    type="submit"
                    disabled={isAdding || isUpdating}
                  >
                    Submit
                  </Button>
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                    type="button"
                    onClick={() => {
                      setModalOpen(false);
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </Col>
            </Form>
          </Col>

          {/* <div className="btnWrpper mt-4 d-flex align-items-center justify-content-center gap-10">
            <div className="px-2 w-100">
              <Button
                onClick={hideHandler}
                className="fw-sbold d-flex align-items-center justify-content-center commonBtn w-100 GreyBtn"
              >
                Cancel
              </Button>
            </div>
            <div className="px-2 w-100">
              <Button
                onClick={confirmHandler}
                className="fw-sbold d-flex align-items-center justify-content-center commonBtn w-100"
              >
                {title}
              </Button>
            </div>
          </div> */}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CategoryPop;
